import { AnnouncementMessages, TranslationAnnouncementMessages } from "../interfaces/announcementMessages";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationAnnouncementMessages = {
  [AnnouncementMessages.menuTitle]: "Notificações",
  [AnnouncementMessages.bellTooltip]: "Notificações",
  [AnnouncementMessages.dropdownTitle]: "NOTIFICAÇÕES",
  [AnnouncementMessages.markAllRead]: "Marcar todas como lidas",
  [AnnouncementMessages.viewAll]: "Ver todas as notificações",
  [AnnouncementMessages.emptyTitle]: "Nenhuma notificação por aqui",
  [AnnouncementMessages.emptySubtitle]: "Notificações e novidades aparecem aqui.",
  [AnnouncementMessages.defaultCta]: "Clique aqui",
  [AnnouncementMessages.bannerHighlight]: "DESTAQUE",
  [AnnouncementMessages.bannerDismiss]: "Fechar",
  [AnnouncementMessages.pageTitle]: "Notificações",
  [AnnouncementMessages.pageSubtitle]: "Notificações exibidas no sino para todos os usuários, dentro do período definido.",
  [AnnouncementMessages.newButton]: "Nova notificação",
  [AnnouncementMessages.manageAccess]: "Gerenciar acesso",
  [AnnouncementMessages.searchPlaceholder]: "Buscar por título",
  [AnnouncementMessages.loadError]: "Erro ao carregar as notificações, tente novamente.",
  [AnnouncementMessages.retry]: "Tentar novamente",
  [AnnouncementMessages.listEmpty]: "Nenhuma notificação cadastrada ainda.",
  [AnnouncementMessages.listTruncated]: "Exibindo {{shown}} de {{total}} notificações.",
  [AnnouncementMessages.tableTitle]: "Título",
  [AnnouncementMessages.tablePeriod]: "Período",
  [AnnouncementMessages.tableStatus]: "Status",
  [AnnouncementMessages.tableReads]: "Leituras",
  [AnnouncementMessages.tableClicks]: "Cliques",
  [AnnouncementMessages.tableActions]: "Ações",
  [AnnouncementMessages.statusActive]: "Ativa",
  [AnnouncementMessages.statusScheduled]: "Agendada",
  [AnnouncementMessages.statusExpired]: "Expirada",
  [AnnouncementMessages.byAuthor]: "por {{name}}",
  [AnnouncementMessages.reachEveryone]: "Todos os clientes",
  [AnnouncementMessages.reachTenantOne]: "1 cliente",
  [AnnouncementMessages.reachTenantMany]: "{{count}} clientes",
  [AnnouncementMessages.reachUserOne]: "1 pessoa",
  [AnnouncementMessages.reachUserMany]: "{{count}} pessoas",
  [AnnouncementMessages.clicksHint]: "Os números de leituras e de cliques abrem a lista de quem recebeu a notificação.",
  [AnnouncementMessages.formTitleNew]: "Nova notificação",
  [AnnouncementMessages.formTitleEdit]: "Editar notificação",
  [AnnouncementMessages.formSubtitle]: "Visível a todos os usuários no período definido.",
  [AnnouncementMessages.fieldTitle]: "Título",
  [AnnouncementMessages.fieldMessage]: "Mensagem",
  [AnnouncementMessages.fieldLink]: "Link",
  [AnnouncementMessages.fieldLinkLabel]: "Texto do botão",
  [AnnouncementMessages.fieldStartDate]: "Início",
  [AnnouncementMessages.fieldEndDate]: "Fim",
  [AnnouncementMessages.fieldHighlight]: "Destacar no Launcher (banner)",
  [AnnouncementMessages.fieldAudience]: "Quem recebe",
  [AnnouncementMessages.audienceEveryone]: "Todos os clientes",
  [AnnouncementMessages.audienceTargeted]: "Escolher quem recebe",
  [AnnouncementMessages.audienceEveryoneHint]: "Todo mundo da suite vê o aviso, em todos os clientes.",
  [AnnouncementMessages.audienceTargetedHint]: "Só os clientes e as pessoas que você escolher abaixo.",
  [AnnouncementMessages.audienceSummaryLabel]: "Vai para",
  [AnnouncementMessages.audienceSummaryEmpty]: "Escolha ao menos um cliente ou uma pessoa.",
  [AnnouncementMessages.targetTenantsHint]: "Todas as pessoas desses clientes recebem.",
  [AnnouncementMessages.fieldTargetTenants]: "Clientes",
  [AnnouncementMessages.fieldTargetUsers]: "Pessoas",
  [AnnouncementMessages.targetUsersHint]: "Busque por nome ou e-mail. A pessoa recebe mesmo que o cliente dela não esteja na lista.",
  [AnnouncementMessages.audienceRequired]: "Selecione ao menos um cliente ou uma pessoa",
  [AnnouncementMessages.recipientSearching]: "Buscando...",
  [AnnouncementMessages.recipientNoResults]: "Ninguém encontrado",
  [AnnouncementMessages.linkHelper]: "Opcionais — com link, o botão da notificação usa este texto (padrão: \"Clique aqui\")",
  [AnnouncementMessages.endAfterStart]: "O fim deve ser depois do início",
  [AnnouncementMessages.confirmDeleteTitle]: "Excluir notificação",
  [AnnouncementMessages.confirmDeleteMessage]: "A notificação some do sino e do banner de todos os usuários. Deseja continuar?",
  [AnnouncementMessages.interactionsTitle]: "Interações da notificação",
  [AnnouncementMessages.interactionsEmpty]: "Nenhuma interação registrada ainda.",
  [AnnouncementMessages.interactionsUser]: "Usuário",
  [AnnouncementMessages.interactionsTenant]: "Tenant",
  [AnnouncementMessages.interactionsReadAt]: "Leu em",
  [AnnouncementMessages.interactionsClickedAt]: "Clicou em",
  [AnnouncementMessages.interactionsEmail]: "E-mail",
  [AnnouncementMessages.interactionsCount]: "Total: {{count}}",
  [AnnouncementMessages.interactionsExport]: "Exportar CSV",
  [AnnouncementMessages.interactionsExportPartial]: "Exportadas {{exported}} de {{total}} linhas. O arquivo está incompleto.",
  [AnnouncementMessages.interactionsExporting]: "Exportando...",
  [AnnouncementMessages.managersTitle]: "Gerenciar acesso",
  [AnnouncementMessages.managersSubtitle]: "Admins que podem criar e gerenciar notificações.",
  [AnnouncementMessages.managersEmpty]: "Nenhum usuário com acesso ainda.",
  [AnnouncementMessages.managersGrantLabel]: "Conceder acesso a um admin",
  [AnnouncementMessages.managersGrantButton]: "Conceder",
  [AnnouncementMessages.managersRevoke]: "Revogar acesso",
  [AnnouncementMessages.managersGrantedBy]: "concedida por {{name}}"
};
